export default __webpack_public_path__ + "static/media/freeUsAddress.0a6df459.svg";